<main class="pv2-new-additional">
  <header class="pv2-new-additional__header">
    <button type="button" class="pv2-new-additional__back" (click)="step === 'editor' ? backToTargets() : goToCatalog()">
      <span class="fa fa-arrow-left"></span>
      <span>{{ step === 'editor' && !savedGroup ? 'Aplicar em' : 'Adicionais' }}</span>
    </button>

    <div class="pv2-new-additional__identity">
      <span class="pv2-new-additional__eyebrow">Novo adicional</span>
      <h1>{{ step === 'targets' ? 'Em quais produtos vai aparecer?' : (step === 'done' ? 'Adicional criado' : 'Configure o adicional') }}</h1>
      <p *ngIf="step === 'targets'">Marque os produtos (ou categorias inteiras). O adicional é criado uma vez e compartilhado entre todos.</p>
      <p *ngIf="step === 'editor'">Ao salvar, o grupo será aplicado a {{ selectedCount }} {{ selectedCount === 1 ? 'produto' : 'produtos' }}.</p>
      <p *ngIf="step === 'done'">Editar este grupo atualiza todos os produtos vinculados.</p>
    </div>

    <ol class="pv2-new-additional__steps" aria-label="Passos">
      <li [class.is-active]="step === 'targets'" [class.is-done]="step !== 'targets'"><span>1</span> Aplicar em</li>
      <li [class.is-active]="step === 'editor'" [class.is-done]="step === 'done'"><span>2</span> Configurar</li>
      <li [class.is-active]="step === 'done'"><span>3</span> Pronto</li>
    </ol>
  </header>

  <section class="pv2-new-additional__loading" *ngIf="loading">
    <span class="fa fa-spinner fa-spin"></span>
    <p>Carregando produtos...</p>
  </section>

  <section class="pv2-new-additional__error" *ngIf="!loading && errorMessage">
    <span class="fa fa-exclamation-circle"></span>
    <div>
      <strong>Algo deu errado</strong>
      <p>{{ errorMessage }}</p>
      <button type="button" (click)="step === 'targets' ? load() : continueToEditor()">Tentar novamente</button>
    </div>
  </section>

  <!-- Passo 1: seleção de produtos -->
  <section class="pv2-new-additional__targets" *ngIf="!loading && !errorMessage && step === 'targets'">
    <app-seletor-produtos-v2
      [empresa]="empresa"
      [preSelecionados]="preSelecionados"
      [podeEditar]="canEditStructure"
      [ocupado]="loadingEditor"
      rotuloAcao="Continuar com"
      (confirmou)="continueToEditor($event)"
      (cancelou)="goToCatalog()">
    </app-seletor-produtos-v2>
  </section>

  <!-- Passo 2: editor -->
  <section class="pv2-new-additional__editor" *ngIf="!loading && !errorMessage && step === 'editor' && editor">
    <div class="pv2-new-additional__targets-chips">
      <span class="fa fa-link"></span>
      <span *ngFor="let product of selectedProducts; trackBy: trackByProduct">{{ product.name }}</span>
      <button type="button" *ngIf="!savedGroup" (click)="backToTargets()">Alterar</button>
    </div>

    <app-tela-editor-adicional-v2
      [standalone]="true"
      [startWithCreate]="true"
      [editor]="editor"
      [empresa]="empresa"
      [podeEditar]="canEditStructure"
      [podeEditarPrecos]="canEditPrices"
      [podeEditarDisponibilidade]="canEditAvailability"
      [podeEditarExibicaoOpcoes]="canEditOptionDisplay"
      [mode]="'create'"
      (closeRequested)="savedGroup ? goToCatalog() : backToTargets()"
      (groupSaved)="onGroupSaved($event)"
      (groupDeleted)="onGroupDeleted()">
    </app-tela-editor-adicional-v2>
  </section>

  <!-- Passo 3: resumo -->
  <section class="pv2-new-additional__done" *ngIf="!loading && step === 'done' && savedGroup">
    <div class="pv2-new-additional__done-card">
      <span class="pv2-new-additional__done-icon fa" [ngClass]="linking ? 'fa-spinner fa-spin' : 'fa-check'"></span>
      <h2>{{ savedGroup.name }}</h2>
      <p>{{ savedGroup.description }} · {{ savedGroup.options.length }} {{ savedGroup.options.length === 1 ? 'opção' : 'opções' }}</p>

      <ul class="pv2-new-additional__results">
        <li class="is-ok" *ngIf="sourceProduct">
          <span class="fa fa-check"></span>{{ sourceProduct.name }}
        </li>
        <li *ngFor="let result of linkResults; trackBy: trackByResult" [class.is-ok]="result.ok" [class.is-failed]="!result.ok">
          <span class="fa" [ngClass]="result.ok ? 'fa-check' : 'fa-times'"></span>
          {{ result.product.name }}
          <small *ngIf="!result.ok">{{ result.error }}</small>
        </li>
      </ul>

      <button type="button" class="pv2-new-additional__retry" *ngIf="linkedFailed.length && !linking" (click)="retryFailedLinks()">
        <span class="fa fa-refresh"></span>
        Tentar de novo nos {{ linkedFailed.length }} que falharam
      </button>
    </div>

    <div class="pv2-new-additional__done-actions">
      <button type="button" (click)="openSavedGroup()">Abrir adicional</button>
      <button type="button" (click)="createAnother()">Criar outro</button>
      <button type="button" class="is-primary" (click)="goToCatalog()">Voltar aos adicionais</button>
    </div>
  </section>
</main>
